import React from 'react';
import CargaMasivaPersonal from '../components/CargaMasivaPersonal';
import DashboardLayout from '../components/DashboardLayout';

const CargaMasivaPage = () => {
    return (
        <DashboardLayout>
            <CargaMasivaPersonal />
        </DashboardLayout>
    );
};

export default CargaMasivaPage;